export const NOT_ATTENDED_STATUS_LABEL = 'NA';

export const STAFF_TRAINING_STATUSES = {
    BEHIND: 'behind',
    ON_TRACK: 'onTrack',
    AHEAD: 'ahead',
} as const;

export type StaffTrainingStatus = (typeof STAFF_TRAINING_STATUSES)[keyof typeof STAFF_TRAINING_STATUSES];

/**
 * The training types a training record may hold: the options the app's editor offers, and the only
 * values the bulk import and the Service API accept (CUR-2301).
 */
export const TRAINING_RECORD_TYPES = ['Internal', 'External'] as const;

export type TrainingRecordType = (typeof TRAINING_RECORD_TYPES)[number];
